import { render, staticRenderFns } from "./ContainerPricing.vue?vue&type=template&id=03f6374a&scoped=true&"
import script from "./ContainerPricing.vue?vue&type=script&lang=js&"
export * from "./ContainerPricing.vue?vue&type=script&lang=js&"
import style0 from "./ContainerPricing.vue?vue&type=style&index=0&id=03f6374a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f6374a",
  null
  
)

export default component.exports